function DonatePage() {
  return (
    <main className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className="text-5xl font-bold text-center mb-8 text-black"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          Support Bay Area Conservatives PAC
        </h1>

        <p className="text-xl text-black text-center mb-12 max-w-3xl mx-auto">
          Your contribution fuels voter outreach, candidate support, and community
          engagement programs across the Clear Lake and Galveston Bay region.
        </p>

        <div className="relative py-16 px-8 rounded-lg shadow-md text-center mb-12">
          <div
            className="absolute inset-0 rounded-lg"
            style={{
              backgroundImage:
                "url(/img/clear-lake-galveston-bay-texas.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gray-800 opacity-40 rounded-lg" />
          </div>

          <div className="relative z-10">
            <a
              href="https://secure.anedot.com/bay-area-conservatives-pac/donate"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-black text-2xl font-bold py-4 px-12 rounded-full shadow-lg hover:bg-gray-100 transition"
            >
              DONATE NOW
            </a>
          </div>
        </div>

        <p className="text-sm text-gray-700 text-center">
          <strong>Contributions are not tax-deductible.</strong>
        </p>
      </div>
    </main>
  );
}

export default DonatePage;
